<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/enrolment/create-course"><i class="fas fa-plus"></i> {{ "CREATE_COURSE" | translate |
                titlecase }}</button> -->
        </div>

        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "ENROLMENR_REPORT_GROUP" | translate | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                
                <div style="text-align: center;font-size: 16px;font-weight: bold;" *ngIf="false">Show message here if enrollment is finilizes</div>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester" (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of batches" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>

                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "GROUP" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="group">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of groups" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.egroupNameAr : field?.egroupNameEn
                                                    }}({{field?.egroupCode}})
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.group.touched && searchForm.controls.group.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-4 form-group px-md-5 mb-1" style="padding-top: 23px;padding-left: 50px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>
                                </form>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="tableAppear" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "MAT_NO" | translate | titlecase }}</th>

                                <th>{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</th>

                                <th>{{ "GENDER" | translate | titlecase }}</th>

                                <th>{{ "STATUS" | translate | titlecase }}</th>

                                <th>{{ "REPEATING_SUBJECT" | translate | titlecase }}</th>
                             </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of students let i = index">
                                <td>{{res?.matno}}</td>
                                <td>{{res?.fullNameEn}}</td>
                                <td class="cursor-pointer">{{ res.gender == "M"? ("MALE" | translate | titlecase) :
                                    ("FEMALE" | translate |
                                    titlecase) }}</td>
                                <td class="cursor-pointer">{{
                                    (globals.lang == 'ar')? res?.sstatusNameAr : res?.sstatusNameEn
                                }}</td>
                                <td>{{
                                    (globals.lang == 'ar')? res?.repeatingSubjectsAr : res?.repeatingSubjectsEn
                                    }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
            </div>
        </div>
    </div>
</div>

